module.exports = __webpack_public_path__ + "static/media/ran.f9fe81e3.png";